import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox, } from "components"
import classes from "./PrinterCategoriesCard.module.scss"

const PrinterCategoriesCard = props => {
  const {
    category,
    isSelected,
    setPrinterCategoryIds
  } = props

  const i18n = useTranslation()[1]

  const handleSwitchCategory = (value) => {
    setPrinterCategoryIds(prev => {
      const object = { ...prev }

      if (value) {
        object[category._id] = true
      } else {
        delete object[category._id]
      }

      return object
    })
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["category"]}>
      <div className={classes["row"]}>
        <div
          className={clsx(
            classes["category-text"],
            isLtr && classes["category-text-ltr"]
          )}
        >
          {category.name}
        </div>
        <Checkbox
          checked={isSelected}
          onChange={(value) =>
            handleSwitchCategory(value)
          }
        />
      </div>
    </div>
  )
}

export default React.memo(PrinterCategoriesCard)